module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Light-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Light-webfont.ttf
// module id = 1629
// module chunks = 0